import { Action, createReducer, on } from "@ngrx/store";
import { HotelsState } from "../model";
import { HotelsStateActions } from "./hotels.actions";
import { hotelsAdapter } from "./hotels.adapter";
import {
  InitialLoadActions,
  InitialLoadActionsWithData,
} from "src/app/libs/data-access/store/shared";
import { SortValueEnum } from "src/app/libs/ui/components/top-bar/enums/top-bar.enum";
import { FilterType } from "src/app/libs/ui/enums/fiters.enums";
import { ResetState } from "src/app/actions/global.actions";

export const initialHotelsState: HotelsState = hotelsAdapter.getInitialState({
  entities: {},
  offerRequestId: "",
  afterCursor: "",
  filtersMetadata: InitialLoadActionsWithData,
  sort: SortValueEnum.TotalAmountAsc,
  requestMetadata: null,
  ids: [],
  totalRecordsLeft: -1,
  totalRecords: 0,
  selectedQuickFilter: 'cheapest',
  loadMoreActions: InitialLoadActions,
  loading: false,
  loaded: false,
  error: null,
  active: [],
  orderInfo:{},
  hotelOrderInfo:{}
});

export const HotelsStateFeatureKey = "HotelsStateFeatureKey";

export const hotelsReducer = createReducer(
  initialHotelsState,
  on(HotelsStateActions.saveHotelFilterConfiguration, (state, action) => {
    const { metadata } = action;

    return {
      ...state,
      filtersMetadata: {
        data: metadata,
        loading: false,
        loaded: false,
        error: null,
      },
    };
  }),

  on(HotelsStateActions.loadHotelsFilterOptions, (state, action) => {
    return {
      ...state,
      filtersMetadata: {
        data: state.filtersMetadata?.data,
        loading: true,
        loaded: false,
        error: null,
      },
    };
  }),

  on(HotelsStateActions.loadHotelsFilterOptionsSuccess, (state, action) => {
    const { filterOptions } = action?.data || {};
    const filtersMetadata = JSON.parse(JSON.stringify(state.filtersMetadata));
    for (let filter of filtersMetadata.data) {
      if (filter.type == FilterType.Slider) {
        filter.options[0].min.defaultValue = filterOptions[filter.id].min;
        filter.options[0].max.defaultValue = filterOptions[filter.id].max;
      }
      if (filter.type == FilterType.Checkbox) {
        for (let data of filterOptions[filter.id]) {
          filter.options[0].options.push(data);
        }
      }
      
    }
    return {
      ...state,
      filtersMetadata: {
        data: [...filtersMetadata.data],
        loading: false,
        loaded: true,
        error: null,
      },
    };
  }),

  on(HotelsStateActions.loadHotelsFilterOptionsFailure, (state, action) => {
    //TODO: add errors
    const { error } = action;
    return {
      ...state,
      filtersMetadata: {
        data: null,
        loading: false,
        loaded: true,
        error,
      },
    };
  }),

  on(HotelsStateActions.loadHotelsData, (state, action) => {
    const { requestQuery } = action;
    return {
      ...state,
      requestMetadata: requestQuery,
      loading: true,
      loaded: false,
      error: null,
    };
  }),

  on(HotelsStateActions.loadHotelsDataSuccess, (state, action) => {
    const { hotels, totalRecordsLeft, totalRecords } = action.data;
    const active = hotels;
    const updatedState = hotelsAdapter.addMany(hotels, state);
    return {
      ...updatedState,
      active,
      totalRecordsLeft,
      totalRecords,
      loading: false,
      loaded: true,
      error: null,
    };
  }),

  on(HotelsStateActions.loadHotelsDataFailure, (state, action) => {
    //TODO: add errors
    const { error } = action;
    return {
      ...state,
      loading: false,
      loaded: true,
      error,
    };
  }),

  on(HotelsStateActions.loadMoreHotelsData, (state, action) => {
    const { requestQuery } = action;
    return {
      ...state,
      requestMetadata: requestQuery,
      loadMoreActions: {
        loading: true,
        loaded: false,
        error: null,
      },
    };
  }),

  on(HotelsStateActions.loadMoreHotelsDataSuccess, (state, action) => {
    const { hotels, totalRecordsLeft } = action.data;
    const active = [...state.active, ...hotels];
    const updatedState = hotelsAdapter.addMany(hotels, state);
    return {
      ...updatedState,
      active,
      totalRecordsLeft,
      loadMoreActions: {
        loading: false,
        loaded: true,
        error: null,
      },
    };
  }),

  on(HotelsStateActions.loadMoreHotelsDataFailure, (state, action) => {
    //TODO: add errors
    const { error } = action;
    return {
      ...state,
      loadMoreActions: {
        loading: false,
        loaded: true,
        error,
      },
    };
  }),
  on(HotelsStateActions.setQuickFilter, (state, action) => {
    const { selectedQuickFilter } = action || {};
    return { //This is a sync action so no need for loading and loaded...
      ...state,
      selectedQuickFilter,
    };
  }),
  on(ResetState, (state:any,action:any) =>{
    
    return {
      ...initialHotelsState,
      filtersMetadata: {
        data: [],
        loading: false,
        loaded: false,
        error: null,
      },
    }
  }),
);

export function HotelsReducer(state: HotelsState | undefined, action: Action) {
  return hotelsReducer(state, action);
}
